'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pureGraph = require('pure-graph');

var _functional = require('utils/functional');

var _utils = require('utils/utils');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* injects from baggage-loader */

var names = ['The Family Dog', 'How to Get Windows 10', 'Дорийский контрапункт контрастных фактур: основные моменты', 'A Robotic Dog’s Mortality', 'Welcome!', 'Some Random Funny Project Name'];

var ID_0 = '-KC-0';
var ID_1 = '-KC-1';

var getStubData = function getStubData() {
  var _nodesData;

  return {
    name: (0, _utils.randomElement)(names),

    nodesData: (_nodesData = {}, _defineProperty(_nodesData, ID_0, { x: -100, y: -25, color: '#D0F192', caption: 'Very beginning' }), _defineProperty(_nodesData, ID_1, { x: 100, y: 25, color: '#6D826C', caption: 'And then…' }), _nodesData),

    graph: (0, _functional.compose)((0, _pureGraph.addEdge)(ID_0 + '-' + ID_1, ID_0, ID_1), (0, _pureGraph.addNode)(ID_1), (0, _pureGraph.addNode)(ID_0))(_pureGraph.EMPTY_GRAPH)
  };
};

exports.default = getStubData;


//////////////////
// WEBPACK FOOTER
// ./app/reducers/projectSimpleStubbedData.js
// module id = 627
// module chunks = 1